import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Toaster, ModuleFE_Thunderstorm, openContent, TS_Input, } from '@nu-art/thunderstorm-frontend';
import { _EmptyQuery } from '@nu-art/firebase-shared';
import { sortArray, voidFunction } from '@nu-art/ts-common';
import { Dialog_Confirmation, ICONS } from '@app/styles';
import { ModuleFE_SimulationDemoEvent, } from '../../_entity/simulation-demo-events/index.js';
import './Panel_SimulationDemoEventsEditor.scss';
export class Panel_SimulationDemoEventsEditor extends ComponentSync {
    // ######################### LifeCycle #########################
    __onSimulationDemoEventUpdated = (..._params) => {
        this.forceUpdate();
    };
    deriveStateFromProps(_nextProps, state) {
        state.loading ??= true;
        return state;
    }
    async componentDidMount() {
        try {
            await ModuleFE_SimulationDemoEvent.v1.query(_EmptyQuery).executeSync();
        }
        catch (e) {
            this.logError(String(e));
            ModuleFE_Toaster.toastError('Could not load demo events');
        }
        finally {
            this.setState({ loading: false });
        }
    }
    // ######################### Logic #########################
    getSortedEvents = () => sortArray(ModuleFE_SimulationDemoEvent.cache.allMutable(), (e) => e.label.toLowerCase());
    saveLabel = async (event, newLabel) => {
        const label = newLabel.trim();
        if (!label) {
            ModuleFE_Toaster.toastError('Label is required');
            this.setState({ editingEventId: undefined });
            return;
        }
        if (label === event.label) {
            this.setState({ editingEventId: undefined });
            return;
        }
        try {
            await ModuleFE_SimulationDemoEvent.v1
                .upsert({ _id: event.eventId, eventId: event.eventId, label })
                .executeSync();
            this.setState({ editingEventId: undefined });
            ModuleFE_Toaster.toastSuccess('Label updated');
        }
        catch (err) {
            this.logError(String(err));
            ModuleFE_Toaster.toastError('Could not update label');
            this.setState({ editingEventId: undefined });
        }
    };
    onDelete = (event) => {
        Dialog_Confirmation.show({
            header: 'Remove demo event?',
            content: (_jsxs(LL_V_L, { className: 'ehr-emulator__demo-events-editor__confirm', children: [_jsx("div", { children: "This removes the demo marker for this encounter event." }), _jsx("div", { className: 'ehr-emulator__demo-events-editor__confirm-id', children: event.eventId })] })),
            buttons: [
                {
                    label: 'Remove',
                    isAsync: true,
                    action: async () => {
                        try {
                            await ModuleFE_SimulationDemoEvent.v1.delete({ _id: event.eventId }).executeSync();
                            ModuleFE_Toaster.toastSuccess('Demo event removed');
                        }
                        catch (err) {
                            this.logError(String(err));
                            ModuleFE_Toaster.toastError('Could not remove demo event');
                        }
                    },
                },
                { label: 'Cancel', isPreferred: true, action: voidFunction },
            ],
        });
    };
    // ######################### Render #########################
    renderDemoEvent = (event) => {
        const isEditing = this.state.editingEventId === event.eventId;
        return (_jsxs(LL_H_C, { className: 'ehr-emulator__demo-events-editor__entry', children: [_jsxs(LL_V_L, { className: 'ehr-emulator__demo-events-editor__entry-body', children: [_jsx(LL_H_C, { className: 'ehr-emulator__demo-events-editor__label-field', children: isEditing ? (_jsx(TS_Input, { type: 'text', className: 'ehr-emulator__demo-events-editor__label-input', value: event.label, focus: true, trim: true, onAccept: (label) => {
                                    this.saveLabel(event, label);
                                }, onCancel: () => this.setState({ editingEventId: undefined }), onBlur: (label) => {
                                    this.saveLabel(event, label);
                                } })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: 'ehr-emulator__demo-events-editor__label', children: event.label }), _jsx(Button, { variant: 'tertiary', className: 'ehr-emulator__demo-events-editor__edit', onClick: () => this.setState({ editingEventId: event.eventId }), ...openContent.tooltip.top(`demo-event-edit-${event.eventId}`, 'Edit label', { offset: 8 }), children: _jsx(ICONS.edit.component, {}) })] })) }), _jsx("div", { className: 'ehr-emulator__demo-events-editor__event-id', onClick: () => ModuleFE_Thunderstorm.copyToClipboard(event.eventId), children: event.eventId })] }), _jsx(Button, { variant: 'tertiary', className: 'ehr-emulator__demo-events-editor__delete', onClick: () => this.onDelete(event), ...openContent.tooltip.top(`demo-event-delete-${event.eventId}`, 'Remove demo event', { offset: 8 }), children: _jsx(ICONS.bin.component, {}) })] }, event.eventId));
    };
    render() {
        const { onClose } = this.props;
        const { loading } = this.state;
        const events = this.getSortedEvents();
        return (_jsxs(LL_V_L, { className: 'ehr-emulator__demo-events-editor', children: [_jsxs(LL_H_C, { className: 'ehr-emulator__demo-events-editor__header', children: [_jsx("span", { className: 'ehr-emulator__demo-events-editor__title', children: "Simulation demo events" }), _jsx(Button, { variant: 'tertiary', className: 'ehr-emulator__demo-events-editor__close', onClick: onClose, ...openContent.tooltip.top('demo-events-editor-close', 'Close', { offset: 8 }), children: _jsx(ICONS.x.component, {}) })] }), _jsx("div", { className: 'ehr-emulator__demo-events-editor__body', children: loading ? (_jsx("div", { className: 'ehr-emulator__demo-events-editor__empty', children: "Loading\u2026" })) : events.length === 0 ? (_jsx("div", { className: 'ehr-emulator__demo-events-editor__empty', children: "No demo events yet. Right click an encounter event in the list and set a label to create one." })) : (events.map(this.renderDemoEvent)) })] }));
    }
}
//# sourceMappingURL=Panel_SimulationDemoEventsEditor.js.map